const hosts = new Set([
  'au.fashionunited.com',
  'bg.fashionunited.com',
  'cy.fashionunited.com',
  'gr.fashionunited.com',
  'ee.fashionunited.com',
  'hr.fashionunited.com',
  'lt.fashionunited.com',
  'lv.fashionunited.com',
  'mt.fashionunited.com',
  'ro.fashionunited.com',
  'sk.fashionunited.com',
  'si.fashionunited.com',
  'fashionunited.at',
  'fashionunited.cz',
  'fashionunited.fi',
  'fashionunited.hk',
  'fashionunited.hu',
  'fashionunited.lu',
  'fashionunited.no',
  'fashionunited.pt',
  'fashionunited.se',
]);

const isLite = (host) => hosts.has(host);

export default isLite;
